import Content from '../../../content';
import DataTables from '../../../components/dataTables';

namespace('IO.Views.FirewallRules', function (exports) {
  'use strict';

  var Index = Content.extend({
    dom: {
      CLONE_ACTION: '.clone-rule',
      CHECKED_RULE: '.rpm-tabs-content .active .row-checkbox:checked',
      DELETE_ACTION: '.delete-rule',
      ONE_SELECTION_ACTION:
        '.rpm-tabs-content .active .dropdown-toggleable-option-one',
      MANY_SELECTION_ACTION:
        '.rpm-tabs-content .active .dropdown-toggleable-option-many',
      SELECTION_ACTION: '.rpm-tabs-content .active .dropdown-toggleable-option',
      TAB: '.rpm-menu a.item',
      RULES_FORM: '#rules-form',
    },

    tabTemplate:
      '<a class="item <%= classes %>" data-tab="tab<%= counter %>"><%= chain %></a>',
    jst_template: 'firewall_rules/tab_content', // eslint-disable-line camelcase

    events: function () {
      var events = {};

      events['tabChange ' + this.dom.TAB] = '_lazyDrawDatatable';
      events['click ' + this.dom.CLONE_ACTION] = '_cloneRule';
      events['click ' + this.dom.DELETE_ACTION] = '_deleteRule';
      return events;
    },

    onDestroy: function () {
      _.each(this.dataTables, function (dataTable) {
        dataTable.remove();
      });
    },

    beforeRender: function () {
      this.tabs = [];
      this.dataTables = [];
    },

    render: function () {
      this._getRules();
    },

    _cloneRule: function (e) {
      var target = e.currentTarget,
        form = $(this.dom.RULES_FORM),
        $selectedRule = this.$(this.dom.CHECKED_RULE),
        csrf = $('meta[name=csrf-token]').attr('content');

      form.attr('action', target.href + '/' + $selectedRule.val() + '/clone');
      form.append(
        "<input type='hidden' name='authenticity_token' value='" +
          csrf +
          "' />",
      );
      form.trigger('submit');
      return false;
    },

    _deleteRule: function (e) {
      var $selectedCheckboxes = this.$(this.dom.CHECKED_RULE),
        $el = $(e.currentTarget),
        baseURL = $el.prop('href'),
        ids,
        names,
        confirmationMSG;

      ids = _.map($selectedCheckboxes, function (checkbox) {
        return checkbox.value;
      });
      names = _.map($selectedCheckboxes, function (checkbox) {
        return '"' + $(checkbox).data('name') + '"';
      });
      confirmationMSG =
        'You are about to delete ' + names.join(', ') + ' firewall rules.';

      if (this.confirmationModal === undefined) {
        this.confirmationModal = new IO.Views.ConfirmationModal({
          el: '#confirmation-modal',
          closable: false,
        });
      }
      this.confirmationModal.show(confirmationMSG, function (proceed) {
        if (proceed) {
          $.ajax({
            type: 'DELETE',
            url: baseURL + '/destroy_multiple',
            data: { 'rules[]': ids },
            headers: {
              'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
            },
          }).done(function () {
            Turbolinks.visit(location.href);
          });
        }
      });

      return false;
    },

    _getRules: function () {
      var self = this;

      $.getJSON(this._currentPath() + '/rules.json', function (data) {
        self.chains = data;
        self._renderTabs();
        self._lazyDrawDatatable(undefined, 'tab0');
      });
    },

    _isDataTableInstantiated: function ($table, indexOf) {
      return !($table.length && indexOf === -1);
    },

    _lazyDrawDatatable: function (e, tab) {
      var alreadyInstantiated = true,
        $table,
        indexOf,
        dataTable;

      if (typeof tab === 'undefined') {
        tab = $(e.target).data('tab');
      }

      $table = this.$('.ui.tab[data-tab="' + tab + '"] table');
      indexOf = this.tabs.indexOf(tab);

      if (!this._isDataTableInstantiated($table, indexOf)) {
        dataTable = new DataTables({
          aoColumnDefs: [
            {
              aTargets: [0],
              mRender: function (data, type, full) {
                return (
                  '<form class="custom"><input type="checkbox" name="rule-checkbox" data-name="' +
                  full[2] +
                  '" class="row-checkbox row' +
                  data +
                  '-checkbox" value="' +
                  data +
                  '"  /></form>'
                );
              },
            },
            {
              aTargets: [3],
              mRender: function (_data, _type, full) {
                return full[3] === true ? 'Enabled' : 'Disabled';
              },
            },
          ],
          columns: window.da_grid_columns,
          controller: document.location.pathname.substr(1) + '/rules',
          el: $('.chain-' + $table.data('chain')),
          editable: false,
          filter: true,
          fixed: false,
          fixedColumns: 2,
          fixedColumnWidth: 110,
          sorting: [[1, 'asc']],
          source: this.chains[$table.data('chain')],
          title: 'Click to edit',
          scrollX: true,
          truncatableColumns: ['Comments'],
        });
        dataTable.start();

        this.dataTables.push(dataTable);
        this.tabs.push(tab);
        this.listenTo(
          dataTable,
          'dataTables:row-selected',
          this._handleActionsDropdown,
        );
        this.trigger('dataTables:new');
        alreadyInstantiated = false;
      }

      if (alreadyInstantiated && this.dataTables[indexOf]) {
        this.dataTables[indexOf].refresh();
      }
    },

    _handleActionsDropdown: function (elements) {
      var empty = elements.length === 0,
        hasOne = elements.length === 1 ? 'inline-block' : 'none',
        hasMany = elements.length > 1 ? 'inline-block' : 'none';

      if (empty) {
        this.$(this.dom.SELECTION_ACTION).hide();
      }

      this.$(this.dom.MANY_SELECTION_ACTION).css({ display: hasMany });
      this.$(this.dom.ONE_SELECTION_ACTION).css({ display: hasOne });
    },

    _renderTabs: function () {
      var $tabs,
        $tabsContent,
        classes,
        counter,
        canEdit,
        newURL,
        baseRulesURL,
        tab,
        tabContent,
        chain;

      counter = 0;
      $tabs = this.$('.rpm-menu');
      $tabsContent = this.$('.rpm-tabs-content');
      canEdit = $tabsContent.data('canedit');
      newURL = $tabsContent.data('new');
      baseRulesURL = '/' + document.location.pathname.substr(1) + '/rules';

      for (chain in this.chains) {
        if (Object.prototype.hasOwnProperty.call(this.chains, chain)) {
          classes = counter === 0 ? 'active ' : '';
          tab = _.template(this.tabTemplate)({
            classes: classes,
            counter: counter,
            chain: chain,
          });
          tabContent = this.render_template({
            classes: classes + 'datatables-container',
            counter: counter,
            chain: chain,
            canEdit: canEdit,
            newURL: newURL,
            baseRulesURL: baseRulesURL,
          });
          $tabs.append(tab);
          $tabsContent.append(tabContent);
          counter += 1;
        }
      }

      refreshTabs();
    },

    _currentPath: function () {
      var href = document.location.href;
      // ex: http://localhost:3000/firewalls/1#tab1 -> http://localhost:3000/firewalls/1
      // ex: http://localhost:3000/firewalls/1# -> http://localhost:3000/firewalls/1
      // ex: http://localhost:3000/firewalls/1 -> http://localhost:3000/firewalls/1
      // ex : http://localhost:3000/ona/firewalls/2?edit=1 -> http://localhost:3000/ona/firewalls/2
      return href.split(/[#?]/)[0];
    },
  });

  exports.Index = Index;
});
